module.exports = __webpack_public_path__ + "af7b3e697d6d2ad652a5a90619300d91.png";